import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import partyServices from '../partyServices';
import moment from 'moment';
import PartyAddressForm from '../components/PartyAddressForm';
import { useAppData } from '../../../../../../context/AppDataContext';
import partyAddressServices from '../partyAddressServices';
import PartyForm from '../components/PartyForm';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';

function PartyDetailsPage() {
    const { id } = useParams();
    const { getMasterLabel } = useAppData();
    const {userDD,ledgerDD,getDDDataById} = useAppData();
    const [partyDetails, setPartyDetails] = useState(null);
    const [partyAddressList, setPartyAddressList] = useState(null);

    const getPartyDetails = () => {
        partyServices.getById(id,true).then(res => {
            setPartyDetails(res.data);
        }).catch(error => {
            console.error("Error fetching party details", error);
        });
    };

    const getPartyAddressList = () => {
        partyAddressServices.getByPartyId(id).then(res => {
            setPartyAddressList(res.data);
        }).catch(error => {
            console.error("Error fetching address list", error);
        });
    };

    useEffect(() => {
        getPartyDetails();
        getPartyAddressList();
    }, [id]);

    if (!partyDetails) return null;

    return (
        <FinanceLayout>
            <div className="container-fluid px-0">
                
                {/* Top Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                    <div>
                        <h2 className="fw-bold mb-0 text-dark">{partyDetails.displayName}</h2>
                    </div>
                    <div>
                        <PartyForm data={partyDetails} callBack={getPartyDetails} />
                    </div>
                </div>

                {/* Main Grid: Vouchers on Left (col-md-8), Details & Addresses on Right (col-md-4) */}
                <div className="row g-4">
                    
                    {/* LEFT COLUMN: Party Voucher List (col-md-8) */}
                    <div className="col-md-8">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-2">
                                

                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Voucher No</th>
                                                <th>Ctreated By</th>
                                                <th>Date</th>
                                                <th>Type</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partyDetails.vouchers.length > 0 ?
                                                partyDetails.vouchers.map(voucher=>
                                                    <tr key={voucher.id}>
                                                        <td>
                                                            {(() => {
                                                                const displayVoucherNo = voucher.voucherNo ? voucher.voucherNo : `Draft-${voucher.voucherType}-${voucher.id}`;

                                                                let linkPath = "";
                                                                if (voucher.voucherType === "Sale" || voucher.voucherType === "Purchase") {
                                                                    linkPath = `/voucher/sale-purchase/details/${voucher.id}`;
                                                                } else if (voucher.voucherType === "Payment" || voucher.voucherType === "Receipt") {
                                                                    linkPath = `/voucher/payment-receipt/details/${voucher.id}`;
                                                                } else if (voucher.voucherType === "Contra" || voucher.voucherType === "Journal" || voucher.voucherType === "CreditNote" || voucher.voucherType === "DebitNote") {
                                                                    linkPath = `/voucher/contra-journal/details/${voucher.id}`;
                                                                } else if (voucher.voucherType === "Expense") {
                                                                    linkPath = `/voucher/expense/details/${voucher.id}`;
                                                                } else if (voucher.voucherType === "ChallanIn" || voucher.voucherType === "ChallanOut") {
                                                                    linkPath = `/voucher/challan/details/${voucher.id}`;
                                                                }

                                                                return linkPath ? (
                                                                    <Link target="_blank" to={linkPath}>
                                                                        {displayVoucherNo}
                                                                    </Link>
                                                                ) : (
                                                                    displayVoucherNo
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>{getDDDataById(userDD,voucher.userId).label}</td>
                                                        <td>{voucher.voucherDate}</td>
                                                        <td>{voucher.voucherType}</td>
                                                        <td>{voucher.grandTotal}</td>
                                                    </tr>
                                                )
                                                :
                                                <tr>
                                                    <td colSpan="6" className="text-center py-5 text-muted">
                                                        No vouchers recorded yet. (Ready for your voucher list implementation)
                                                    </td>
                                                </tr>
                                            }
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN: Details & Addresses Sidebar (col-md-4) */}
                    <div className="col-md-4">
                        <div className="d-flex flex-column gap-4">
                            
                            {/* Financial Summary Widget */}
                            <div className="card border-0 shadow-sm bg-light">
                                <div className="card-body p-3">
                                    <h6 className="fw-semibold mb-3 text-secondary">Financial Overview</h6>
                                    <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                                        <span className="text-muted small">Credit Limit</span>
                                        <span className="fw-bold text-dark">{partyDetails.creditLimit ?? '0.00'}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted small">Current Balance</span>
                                        <span className={`fw-bold ${partyDetails.balance >= 0 ? "text-success" : "text-danger"}`}>
                                            {partyDetails.balance ?? '0.00'}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <Link to={"/ledger-details/"+partyDetails.ledgerId}>Show Ledgers</Link>
                                    </div>
                                </div>
                            </div>

                            {/* General & Tax Info Card */}
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-4">
                                    <h5 className="fw-semibold mb-3 text-secondary">General Information</h5>
                                    <div className="mb-3">
                                        <small className="text-muted d-block">Contact Person</small>
                                        <span className="fw-medium text-dark">{partyDetails.contactPerson || '—'}</span>
                                    </div>
                                    <div className="mb-3">
                                        <small className="text-muted d-block">Party Since</small>
                                        <span className="fw-medium text-dark">{moment(partyDetails.created_at).format("LL")}</span>
                                    </div>
                                    <div className="mb-3">
                                        <small className="text-muted d-block">Phone Number</small>
                                        <span className="fw-medium text-dark">{partyDetails.phone || '—'}</span>
                                    </div>
                                    <div className="mb-3">
                                        <small className="text-muted d-block">Email Address</small>
                                        <span className="fw-medium text-dark">{partyDetails.email || '—'}</span>
                                    </div>

                                    {partyDetails.taxDetails && (
                                        <>
                                            <hr className="my-3 text-muted opacity-25" />
                                            <h6 className="fw-semibold mb-3 text-secondary">Tax Details</h6>
                                            <div className="mb-2">
                                                <small className="text-muted d-block">GSTIN</small>
                                                <span className="fw-medium text-dark">{partyDetails.taxDetails.gstin || '—'}</span>
                                            </div>
                                            <div className="mb-2">
                                                <small className="text-muted d-block">PAN No</small>
                                                <span className="fw-medium text-dark">{partyDetails.taxDetails.panNo || '—'}</span>
                                            </div>
                                            <div className="mb-2">
                                                <small className="text-muted d-block">TDS Applicable</small>
                                                <span className={`badge ${partyDetails.taxDetails.tdsApplicable ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`}>
                                                    {partyDetails.taxDetails.tdsApplicable ? "Yes" : "No"}
                                                </span>
                                            </div>
                                            <div className="mb-2">
                                                <small className="text-muted d-block">Registration Type</small>
                                                <span className="fw-medium text-dark">{getMasterLabel("registration-type", partyDetails.taxDetails.registrationType) || '—'}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Addresses Card */}
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="fw-semibold mb-0 text-secondary">Addresses</h5>
                                        <PartyAddressForm partyId={partyDetails.id} callback={getPartyAddressList} />
                                    </div>

                                    <div>
                                        {partyAddressList && partyAddressList.length === 0 && (
                                            <div className="text-center py-3 text-muted small">No addresses found.</div>
                                        )}

                                        {partyAddressList && partyAddressList.map(partyAddress => (
                                            <div className="p-3 bg-light rounded mb-2 border-0" key={partyAddress.id}>
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <h6 className="fw-bold text-dark mb-1 small">{partyAddress.contactPerson || 'Location Contact'}</h6>
                                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                            {partyAddress.address}, {partyAddress.city}, {getMasterLabel("indian-state", partyAddress.state)} - {partyAddress.zip}
                                                        </p>
                                                        <small className="text-secondary" style={{ fontSize: '0.75rem' }}>
                                                            📞 {partyAddress.phone} | ✉️ {partyAddress.email}
                                                        </small>
                                                    </div>
                                                    <div>
                                                        <PartyAddressForm partyId={partyDetails.id} data={partyAddress} callback={getPartyAddressList} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </FinanceLayout>
    );
}

export default PartyDetailsPage;